var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_2779)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6125 6.41794C17.2094 5.71681 16.1469 5.71681 15.7439 6.41794L15.7435 6.41864L4.81214 25.4004L4.81171 25.4012C4.44961 26.0345 4.89332 26.8921 5.7457 26.8921H27.6107C28.4631 26.8921 28.9068 26.0346 28.5447 25.4013L28.5443 25.4004L17.6129 6.41864L17.6125 6.41794ZM19.346 5.42054C18.1739 3.3826 15.1825 3.38261 14.0104 5.42055L14.01 5.42124L3.07788 24.4043L3.07676 24.4062C1.90714 26.4478 3.44342 28.8921 5.7457 28.8921H27.6107C29.913 28.8921 31.4493 26.4478 30.2796 24.4062L30.2785 24.4043L19.3464 5.42124L19.346 5.42054ZM16.6781 12.8921C17.2304 12.8921 17.6781 13.3398 17.6781 13.8921V18.8921C17.6781 19.4444 17.2304 19.8921 16.6781 19.8921C16.1258 19.8921 15.6781 19.4444 15.6781 18.8921V13.8921C15.6781 13.3398 16.1258 12.8921 16.6781 12.8921ZM18.1781 23.3921C18.1781 24.2205 17.5065 24.8921 16.6781 24.8921C15.8496 24.8921 15.1781 24.2205 15.1781 23.3921C15.1781 22.5637 15.8496 21.8921 16.6781 21.8921C17.5065 21.8921 18.1781 22.5637 18.1781 23.3921Z",
    fill: "url(#paint0_linear_191_2779)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_2779",
    x1: 6.49848,
    y1: 9.19311,
    x2: 30.0886,
    y2: 27.3017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FED961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FEE180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFCA47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_2779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.678223 0.89209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.1f1b066c0782ffb2a4cc5da8f00cfa53.svg";
export { ForwardRef as ReactComponent };